'use es6';

import $ from 'jquery';
import { INLINE_EDITOR_CSS_ELEMENT_ID } from 'ContentEditorUI/ts/ContentAssetsTypes';
const ACTIVE_CLASS = 'inpage-editor-active-field';
const ACTIVE_CLASS_SELECTOR = `.${ACTIVE_CLASS}`;
export const HIGHLIGHTED_CLASS = 'inpage-editor-highlight-field';
export const MODULE_PLACEHOLDER_CLASS = 'hs-ipe-widget-placeholder';
const MODULE_PLACEHOLDER_CLASS_SELECTOR = `.${MODULE_PLACEHOLDER_CLASS}`;
export const MODULE_PLACEHOLDER_CLASS_LARGE = 'hs-ipe-large-placeholder';
export const SERVER_SIDE_PLACEHOLDER_CLASS = 'hs-module-editor-placeholder';
export const SERVER_SIDE_PLACEHOLDER_SELECTOR = `.${SERVER_SIDE_PLACEHOLDER_CLASS}`;
// TODO: Eventually remove this selector in favor of only using the attribute selector
const ISLAND_ID_SELECTOR = '[id^="island-"]';
const ISLAND_ATTRIBUTE_SELECTOR = '[data-hs-island="true"]';
export const UNDERLINE = 'underline';
export const HIGHLIGHT = 'highlight';
export const getSelectorForModuleByName = moduleName => {
  return `#hs_cos_wrapper_${moduleName}`;
};
export const getContainerElementByName = containerName => document.querySelector(getSelectorForModuleByName(containerName));
export const getModuleElement = module => {
  return document.querySelector(`#hs_cos_wrapper_${module.get('name')}`);
};
export const getChildModulesOfFlexColumn = flexColumn => {
  const flexColumnElement = getModuleElement(flexColumn);
  const childNodes = [];
  flexColumnElement.querySelectorAll('.hs_cos_wrapper_widget').forEach(moduleNode => {
    // Sometimes the querySelector above will grab grand children nodes
    // that may no longer be attached to the DOM if it's parent node
    // was already removed on a previous iteration of this forEach loop.
    // So make sure we only attempting to remove direct descedents
    if (moduleNode.parentNode === flexColumnElement) {
      childNodes.push(moduleNode);
    }
  });
  return childNodes;
};
export const containsModulePlaceholder = el => {
  return !!el.querySelector(MODULE_PLACEHOLDER_CLASS_SELECTOR);
};
export const addActiveClass = ($el = false) => {
  const classes = [ACTIVE_CLASS];
  classes.push('updated-editor-styles');
  if ($el) {
    if ($el.addClass) {
      $el.addClass(classes);
    } else {
      $el.classList.add(...classes);
    }
  }
};
export const removeActiveClass = ($el = false) => {
  const classes = [ACTIVE_CLASS];
  classes.push('updated-editor-styles');
  if ($el) {
    if ($el.removeClass) {
      $el.removeClass(classes);
    } else {
      $el.classList.remove(...classes);
    }
  }
};
export const addHighlightedClass = el => {
  el.classList.add(HIGHLIGHTED_CLASS);
};
export const removeHighlightedClass = el => {
  el.classList.remove(HIGHLIGHTED_CLASS);
};
export const setEditorCss = cssString => {
  const $newStyle = $(`<style id="${INLINE_EDITOR_CSS_ELEMENT_ID}" type="text/css" />`).text(cssString);
  if ($(`#${INLINE_EDITOR_CSS_ELEMENT_ID}`).length) {
    $(`#${INLINE_EDITOR_CSS_ELEMENT_ID}`).replaceWith($newStyle);
  } else {
    // Note the `#hs_editor_style` element will only exist exist if the page last rendered on the
    // server had any custom styles
    $('head').append($newStyle);
  }
};
export const getModuleMenuPositionInfo = () => {
  return {
    widgetPosition: $(ACTIVE_CLASS_SELECTOR).offset(),
    widgetHeight: $(ACTIVE_CLASS_SELECTOR).height(),
    widgetWidth: $(ACTIVE_CLASS_SELECTOR).width(),
    widgetId: $(ACTIVE_CLASS_SELECTOR).attr('id')
  };
};

// Similar to scrollToElementIfOffscreen, but will scroll to module if
// any portion of it's bounds are off viewport
export const scrollToModuleElementIfBoundsOffScreenAtAll = moduleId => {
  const moduleElement = getContainerElementByName(moduleId);
  const clientRect = moduleElement.getBoundingClientRect();
  if (clientRect.top < 0 || clientRect.bottom > window.innerHeight) {
    const toScrollTo = window.pageYOffset + clientRect.top - 80;
    $('html, body').animate({
      scrollTop: Math.max(toScrollTo, 0)
    }, 400);
  }
};

// Similar to scrollToModuleElementIfBoundsOffScreenAtAll, but will only
// only scroll if the entire module element is off viewport
export const scrollToElementIfOffscreen = $el => {
  const currentScrollTop = $('html').scrollTop();
  const currentViewportHeight = $(window).height();
  const widgetOffset = $el.offset();
  const widgetHeight = $el.height();
  if (currentScrollTop + currentViewportHeight < widgetOffset.top ||
  // is the element off the bottom of the viewport
  widgetOffset.top + widgetHeight < currentScrollTop // is the element above the top of the viewport
  ) {
    const toScrollTo = widgetOffset.top - 80;
    $('html, body').animate({
      scrollTop: Math.max(toScrollTo, 0)
    }, 400);
  }
};
export const replaceModuleNameInHtml = (originalModuleHtml, originalModuleName, newModuleName) => {
  // Search and replace _all_ via split/join instead of replace so that we don't have to
  // escape Regex chars in oldName
  return originalModuleHtml.split(originalModuleName).join(newModuleName);
};
export const hydrateHtmlStringIntoDomElement = htmlString => {
  const tempDiv = document.createElement('div');
  tempDiv.insertAdjacentHTML('afterbegin', htmlString);
  return tempDiv.firstChild;
};
export const getJsModuleHasIsland = domNode => {
  return Boolean(domNode.querySelector(ISLAND_ATTRIBUTE_SELECTOR)) || Boolean(domNode.querySelector(ISLAND_ID_SELECTOR));
};
export const clearHighlights = highlightedElements => {
  highlightedElements.forEach(item => {
    item.replaceWith(...item.childNodes);
    item.normalize();
  });
};
export const underlineOrHighLight = (xrayReadabilityConfig, type = UNDERLINE) => {
  // the module name of where the selection would be,
  // the offset of where the selection starts
  // the length of the selection
  const {
    moduleName,
    offset,
    length
  } = xrayReadabilityConfig;
  const isUnderLine = type === UNDERLINE;
  const moduleContainer = getContainerElementByName(moduleName);
  const highlightedElements = [];
  const walker = document.createTreeWalker(moduleContainer, NodeFilter.SHOW_TEXT);
  let allRangesFound = false;
  let remainingLength = length;
  let remainingOffset = offset;
  const textNodeRanges = [];
  while (walker.nextNode() && !allRangesFound) {
    const currentNode = walker.currentNode;
    const currentNodeValue = currentNode.nodeValue;
    const currentNodeLength = currentNodeValue.length;

    // Haven't found the start node yet so we skip this node
    //for some reason sometimes the unit test will walk to an empty node
    if (remainingOffset - currentNodeLength >= 0 || !currentNodeValue) {
      remainingOffset -= currentNodeLength;
      continue;
    }
    // Compute the start offset of the range. If the remaining offset is > 0, then we must be at the
    // first node for the list of ranges and may have to add an offset > 0
    const rangeStartOffset = remainingOffset > 0 ? remainingOffset : 0;
    // Compute the end offset. If the remainingLength is longer than the current string, we need the entire string.
    // Otherwise, we only need the slice that ends at remainingLength

    const rangeEndOffset = remainingLength - currentNodeLength + rangeStartOffset >= 0 ? currentNodeLength : remainingLength + rangeStartOffset;

    // Initialize Range with the currentNode, rangeStartOffset, and rangeEndOffset and push it to list
    const range = new Range();
    range.setStart(currentNode, rangeStartOffset);
    range.setEnd(currentNode, rangeEndOffset);
    textNodeRanges.push(range);
    remainingOffset -= currentNodeLength;
    remainingLength -= currentNodeLength;
    if (remainingLength <= 0) {
      allRangesFound = true;
    }
  }

  //scroll to element if off screen
  const $moduleSelector = $(getSelectorForModuleByName(moduleName));
  scrollToElementIfOffscreen($moduleSelector);

  //wrap each range of selection inside underline or highlight element
  textNodeRanges.forEach(nodeRange => {
    let markedItem;
    if (isUnderLine) {
      markedItem = document.createElement('span');
      markedItem.classList.add('underline-fix');
    } else {
      markedItem = document.createElement('mark');
      markedItem.classList.add('highlight-fix');
    }
    highlightedElements.push(markedItem);
    nodeRange.surroundContents(highlightedElements[highlightedElements.length - 1]);
  });
  return highlightedElements;
};